import { render, staticRenderFns } from "./OnlineSwitchRoot.vue?vue&type=template&id=32e11d50"
import script from "./OnlineSwitchRoot.vue?vue&type=script&lang=ts"
export * from "./OnlineSwitchRoot.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports